// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "article h1{font-size:50px}p.metadata{margin-bottom:0}span.posted-on,span.readtime{margin-left:20px}", ""]);
// Exports
module.exports = exports;
